var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-tooltip-with-slot-text',{attrs:{"position":"bottom"},scopedSlots:_vm._u([{key:"text",fn:function(){return [_c('span',{staticClass:"tooltip-content"},[_vm._v(_vm._s(_vm.errorMessage))])]},proxy:true},{key:"inner",fn:function(){return [_c('span',{staticClass:"material-icons error-icon"},[_vm._v("\n      error\n    ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }